<template>
    <div
        class="t-shops-row"
        :class="{ 't-shops-row--active': selectedSubscription }"
    >
        <ui-checkbox-input
            v-model="selectedSubscription"
            class="text-sm"
            :name="`stop-sub-${subscription.id}`"
            :label="setShopLabel"
        />
    </div>
</template>

<script>
export default {
    props: {
        subscription: {
            type: Object,
            required: true
        }
    },

    computed: {
        merchant() {
            return this.$store.getters.getMerchantById(
                this.subscription.merchant_id
            )
        },

        promoGroup() {
            return this.$store.getters.getPromoGroups[0]
        },

        selectedSubscription: {
            get() {
                return this.$store.getters.getSubscriptionToStopById(
                    this.subscription.id
                ).checked
            },
            set(value) {
                this.$store.dispatch('selectSubToStop', {
                    id: this.subscription.id,
                    value
                })

                if (value === false) {
                    this.$store.dispatch('setSelectAllSubscriptions', false)
                }
            }
        },

        setShopLabel() {
            const data = this.merchant
            return `${data.name}, ${this.$store.getters.getShopAddress(data)}`
        }
    }
}
</script>
